<template>
  <InfuseTag :variant="FriendlyStatusColors[status]" :disabled="disabled" :size="size" @click="onClick">
    <font-awesome-icon :icon="FriendlyStatusIcon[status]" class="mr-2" />
    {{ t(`chargingStation.friendlyStatus.${status.toUpperCase()}`) }}
  </InfuseTag>
</template>

<script lang="ts" setup>
import { InfuseTag } from '@infuse/ui/components';
import { FriendlyStatus, FriendlyStatusIcon, FriendlyStatusColors } from '@infuse/cpms/charging-station/store';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

interface Emits {
  (e: 'click'): void;
}

const emit = defineEmits<Emits>();

interface Props {
  status: FriendlyStatus;
  clickable?: boolean;
  disabled?: boolean;
  size?: 'xs' | 'sm' | 'base' | 'md' | 'lg';
}

const props = withDefaults(defineProps<Props>(), {
  clickable: false,
  disabled: false,
  size: 'md'
});

function onClick() {
  if (props.clickable) {
    emit('click');
  }
}
</script>
